import Roll, { articleRollFetch, RollArticles } from "./components/ArticleRoll";
import Post, { PostProps } from "./components/Post";
import PostPreview, { PostPreviewProps } from "./components/PostPreview";
import {
    ArticleDetail,
    ArticleDetailType,
    getArticleDetails,
    getPostPaths,
    PostPaths
} from "./queries";

export type {
    RollArticles,
    PostPreviewProps,
    ArticleDetail,
    PostProps,
    PostPaths,
    ArticleDetailType
};

export default {
    Roll,
    articleRollFetch,
    PostPreview,
    getArticleDetails,
    Post,
    getPostPaths
};
